import React from 'react';
import { DatePicker, Drawer, Input, Radio, Select } from 'antd';
import { helper } from 'utils';
import MaterialIcon from './MaterialIcon';

const Filter = ({ filters, setFilters, doFilter }) => {
	const [open, setOpen] = React.useState(false);

	return (
		<React.Fragment>
			<div>
				<button
					className={`btn btn-lg btn-default- btn-rounded mr-2`}
					onClick={() => doFilter()}
				>
					<i className="fa fa-sync" />
				</button>
				<button
					className={`btn btn-lg btn-secondary btn-rounded mr-2-`}
					type="submit"
					onClick={() => setOpen(true)}
				>
					&nbsp; &nbsp; &nbsp; <i className="fa fa-filter" /> Filter &nbsp;
					&nbsp; &nbsp;
				</button>
			</div>

			<Drawer
				open={open}
				title={null}
				width={400}
				closable={false}
				maskClosable={false}
			>
				<form
					onSubmit={(e) => {
						e.preventDefault();
						doFilter();
						setOpen(false);
					}}
				>
					<div className="d-flex justify-content-between align-items-center mb-4">
						<h2 className="fw-600 text-xl">Filters</h2>
						<div className="pointer" onClick={() => setOpen(false)}>
							{/* <Tag style={{ borderRadius: '100%' }}>
								
							</Tag> */}
							<MaterialIcon name="X" className="" />
						</div>
					</div>

					{filters.map((filter, index) => (
						<div key={index} className="">
							<div className="form-group">
								{filter.label && (
									<div className="mb-2 fw-500">
										{helper.capitalize(filter.label)}
									</div>
								)}
								{filter.type === 'select' && (
									<Select
										size="large"
										placeholder={filter.label}
										style={{ width: '100%' }}
										value={filter.value}
										showSearch={!!(filter.options?.length > 6)}
										mode={filter.multi ? 'multiple' : undefined}
										optionFilterProp="children"
										onChange={(e) =>
											setFilters((sf) => ({ ...sf, [filter.key]: e }))
										}
									>
										{!filter.multi && (
											<Select.Option value="">{filter.label}</Select.Option>
										)}
										{filter.options?.map((item) => (
											<Select.Option
												key={item.value || item}
												value={item.value || item}
											>
												{item.label || item}
											</Select.Option>
										))}
									</Select>
								)}
								{filter.type === 'radio' && (
									<Radio.Group
										size="large"
										style={{ width: '100%' }}
										value={filter.value}
										onChange={(e) =>
											setFilters((sf) => ({
												...sf,
												[filter.key]: e.target.value,
											}))
										}
									>
										{filter.options?.map((item) => (
											<Radio
												key={item.value || item}
												value={item.value || item}
												className="mr-3"
											>
												{helper.capitalize(item.label || item)}
											</Radio>
										))}
									</Radio.Group>
								)}
								{filter.type === 'text' && (
									<Input
										size="large"
										autoComplete="off"
										allowClear
										placeholder={filter.label}
										style={{ width: '100%' }}
										value={filter.value}
										onChange={(e) =>
											setFilters((sf) => ({
												...sf,
												[filter.key]: e.target.value,
											}))
										}
									/>
								)}
								{filter.type === 'date' && (
									<DatePicker.RangePicker
										size="large"
										format="DD-MMM-YYYY"
										allowClear={false}
										style={{ width: '100%' }}
										value={filter.value}
										disabledDate={(d) =>
											filter.range &&
											d &&
											!d.isBetween(filter.range[0], filter.range[1])
										}
										onChange={(e) =>
											setFilters((sf) => ({ ...sf, [filter.key]: e }))
										}
									/>
								)}
							</div>
						</div>
					))}

					<p>&nbsp;</p>
					<p>&nbsp;</p>

					<div
						className="d-flex justify-content-between mt-4 p-4"
						style={{
							position: 'absolute',
							bottom: 20,
							backgroundColor: '#fff',
							bottom: 0,
							left: 0,
							right: 0,
							boxShadow: '0 -2px 6px rgba(0,0,0,.1)',
						}}
					>
						{/* <button
                            className={`btn btn-lg btn-default mr-2 block`}
                            type="button"
                            onClick={() => setFilters({})}
                        >
                            Clear
                        </button> */}
						<div>&nbsp;</div>
						<button
							className={`btn btn-lg btn-secondary btn-rounded block`}
							type="submit"
						>
							Apply
						</button>
					</div>
				</form>
			</Drawer>
		</React.Fragment>
	);
};

export default Filter;
